/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown>, bestStreak: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Game_Meta_RandomInputs */

const bn_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} পয়েন্ট • সেরা স্ট্রীক ${i?.bestStreak} • ${i?.elapsed}`)
};

const de_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} Punkte • Beste Serie ${i?.bestStreak} • ${i?.elapsed}`)
};

const el_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} πόντοι • Καλύτερο σερί ${i?.bestStreak} • ${i?.elapsed}`)
};

const en_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} points • Best streak ${i?.bestStreak} • ${i?.elapsed}`)
};

const es_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} puntos • Mejor racha ${i?.bestStreak} • ${i?.elapsed}`)
};

const fr_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} points • Meilleure série ${i?.bestStreak} • ${i?.elapsed}`)
};

const hi_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} अंक • सर्वोत्तम स्ट्रीक ${i?.bestStreak} • ${i?.elapsed}`)
};

const hu_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} pont • Legjobb sorozat ${i?.bestStreak} • ${i?.elapsed}`)
};

const id_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} poin • Rekor terbaik ${i?.bestStreak} • ${i?.elapsed}`)
};

const it_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} punti • Miglior serie ${i?.bestStreak} • ${i?.elapsed}`)
};

const ja_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} ポイント • 最高の連続記録 ${i?.bestStreak} • ${i?.elapsed}`)
};

const ko_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} 포인트 • 최고 연속 기록 ${i?.bestStreak} • ${i?.elapsed}`)
};

const nl_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} punten • Beste reeks ${i?.bestStreak} • ${i?.elapsed}`)
};

const pl_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} punktów • Najlepsza passa ${i?.bestStreak} • ${i?.elapsed}`)
};

const pt_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} pontos • Melhor sequência ${i?.bestStreak} • ${i?.elapsed}`)
};

const ru_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} очков • Лучшая серия ${i?.bestStreak} • ${i?.elapsed}`)
};

const sv_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} poäng • Bästa rad ${i?.bestStreak} • ${i?.elapsed}`)
};

const tr_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} puan • En iyi seri ${i?.bestStreak} • ${i?.elapsed}`)
};

const uk_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} очок • Найкраща серія ${i?.bestStreak} • ${i?.elapsed}`)
};

const vi_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} điểm • Thành tích tốt nhất ${i?.bestStreak} • ${i?.elapsed}`)
};

const zh_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} 分 • 最佳记录 ${i?.bestStreak} • ${i?.elapsed}`)
};

const zh_hant_game_meta_random = /** @type {(inputs: Game_Meta_RandomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.score} 分 • 最佳記錄 ${i?.bestStreak} • ${i?.elapsed}`)
};

/**
* | output |
* | --- |
* | "{score} points • Best streak {bestStreak} • {elapsed}" |
*
* @param {Game_Meta_RandomInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_meta_random = /** @type {((inputs: Game_Meta_RandomInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Meta_RandomInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_meta_random(inputs)
	if (locale === "de") return de_game_meta_random(inputs)
	if (locale === "el") return el_game_meta_random(inputs)
	if (locale === "en") return en_game_meta_random(inputs)
	if (locale === "es") return es_game_meta_random(inputs)
	if (locale === "fr") return fr_game_meta_random(inputs)
	if (locale === "hi") return hi_game_meta_random(inputs)
	if (locale === "hu") return hu_game_meta_random(inputs)
	if (locale === "id") return id_game_meta_random(inputs)
	if (locale === "it") return it_game_meta_random(inputs)
	if (locale === "ja") return ja_game_meta_random(inputs)
	if (locale === "ko") return ko_game_meta_random(inputs)
	if (locale === "nl") return nl_game_meta_random(inputs)
	if (locale === "pl") return pl_game_meta_random(inputs)
	if (locale === "pt") return pt_game_meta_random(inputs)
	if (locale === "ru") return ru_game_meta_random(inputs)
	if (locale === "sv") return sv_game_meta_random(inputs)
	if (locale === "tr") return tr_game_meta_random(inputs)
	if (locale === "uk") return uk_game_meta_random(inputs)
	if (locale === "vi") return vi_game_meta_random(inputs)
	if (locale === "zh") return zh_game_meta_random(inputs)
	return zh_hant_game_meta_random(inputs)
});